import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { IngressService } from "../../../../services/IngressService";
moment.locale("es");

export const useCompanyOnboardingManager = (changeAlert: ChangeAlertCallbackType) => {
    const [loading, setLoading] = useState(false);
    const [getCompanyList, setGetCompanyList] = useState(false);
    const ingressService = useRef<IngressService>();

    const companyLinkCreate = async (data) => {
        setLoading(true);

        const response = await ingressService.current.companyInsert(data);
        if (response["data"].response === "OK") {
            setLoading(false);
            handleGet(true);
            changeAlert(true, "success", "El link se generó con éxito");
        } else {
            setLoading(false);
            changeAlert(true, "error", response["message"] || response["data"].message || "El cliente no pudo ser creado");
        }
    };

    const companyUpdate = async (data) => {
        setLoading(true);

        const response = await ingressService.current.companyUpdate(data);
        if (response["data"].response === "OK") {
            setLoading(false);
            handleGet(true);
            changeAlert(true, "success", "El registro se actualizó con éxito");
        } else {
            setLoading(false);
            changeAlert(true, "error", response["message"] || response["data"].message || "El cliente no pudo ser creado");
        }
    };

    const companyDelete = async (data) => {
        setLoading(true);

        const response = await ingressService.current.companyDelete(data);
        if (response["data"].response === "OK") {
            setLoading(false);
            handleGet(true);
            changeAlert(true, "success", "El registro se eliminó con éxito");
        } else {
            setLoading(false);
            changeAlert(true, "error", response["message"] || response["data"].message || "El cliente no pudo ser creado");
        }
    };

    const handleGet = async (value) => {
        setGetCompanyList(value);
    };

    useEffect(() => {
        ingressService.current = new IngressService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { loading, getCompanyList, companyLinkCreate, companyUpdate, companyDelete, handleGet };
};
